import gql from 'graphql-tag'
import { version } from 'src/config'
import Model, { encoders, ID, IsoDateTime, JsonObject } from 'src/models/model'
import RegisterStation from 'src/models/register/RegisterStation'

export default class RegisterClient extends Model {
  static name = 'RegisterClient'

  static versioned = true

  static paginate = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.HardwareAndRegisterStation]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      registerStation: {
        type: RegisterStation,
        encode: encoders.hasOne,
        reference: true,
        default: null
      },
      stripeTerminalSerialNumber: {
        type: String,
        default: null
      },
      action: {
        type: String,
        input: true,
        default: null
      },
      indyVersion: {
        type: String,
        output: true
      },
      electronVersion: {
        type: String,
        output: true
      },
      isElectronMode: {
        type: Boolean,
        output: true
      },
      lastOnline: {
        type: IsoDateTime,
        output: true
      },
      paymentConnectorMaintenanceAction: {
        type: JsonObject,
        input: true
      },
      status: {
        type: JsonObject,
        output: true,
        excludeFromDefault: true
      },
      paymentConnectorRestRequest: {
        type: JsonObject,
        output: true
      }
    }

    this.queries = {
      currentRegisterClient: {
        results: {
          registerClient: RegisterClient
        }
      }
    }
  }

  get stripeTerminalLocationId () {
    return this.registerStation?.registerType?.stripeTerminalLocationId
  }

  async updateEnvironmentStatus (electronVersion = null, memoryStatistics = {}, oPosStatus = null) {
    const mutation = gql`mutation ($input: SendRemoteCommandInput!){
      sendRemoteCommand(input: $input) {
        recipientCount
        errors {
          code
          description
        }
      }
    }`

    const command = 'update-environment-status'
    const data = { electron_version: electronVersion, indy_version: version, memory_statistics: memoryStatistics, opos_status: oPosStatus }
    const destination = ''

    const result = await Model.apollo.mutate({
      mutation,
      variables: {
        input: {
          remoteCommandInput: {
            command,
            data,
            destination
          }
        }
      }
    })

    return result.data.sendRemoteCommand
  }
}
